export default {
  SET_DATA_CONTACT(state, data) {
    state.contact_data = data
  },
  DEL_DATA_CONTACT(state) {
    state.contact_data = null
  },
  APP_USE(state, data) {
    state.use_app = data
  }
}
